module.exports = __webpack_public_path__ + "img/BZFZ.df337528.png";